function Diet($, $obj) {
    if (this == window) {
        return new Diet($, $obj);
    }
    var self = this;
    this.$obj = $obj;
    this.$ = $;
    this.$juices = $obj.find(".open_product_popup");
    this.$caption = $obj.find(".bundle__juice_caption");
    $obj.on("mouseover", ".open_product_popup", function () {
        self.highlightStart(this);
    });
    $obj.on("mouseout", ".open_product_popup", function () {
        self.highlightOver(this);
    });
    return this;
};
Diet.prototype.highlightStart = function (img) {
    this.$juices.not(img).addClass("dim");
    this.$(img).addClass("active");
    this.$caption.addClass("active").html(this.$(img).data("product_name") + '<span class="skladniki"> - ' + this.$(img).data("ingredients") + '</span>');
};
Diet.prototype.highlightOver = function () {
    this.$caption.removeClass("active");
    this.$juices.removeClass("dim").removeClass("active");
};

(function ($) {
    //add hooks
    $(".bundle").each(function () {
        new Diet($, $(this));

        let btn = $(this).find('.info_toggle'),
            desc = $(this).find('.diet__description');

        btn.click(function () {
            desc.toggleClass('open')
        });

    });

})(jQuery);


// WEBPACK FOOTER //
// ./assets/js/diet.js